/**
 * Where PF v2 sends the client when its own flag reads false.
 *
 * `RouteSwitch` already picks v2 or legacy from that flag, so this only fires on
 * a disagreement between the two evaluations — an LD streaming update mid-session
 * being the realistic one. Inside the CRM iframe the fallback must stay on the
 * embed path: `RouteSwitch` then renders legacy in place, whereas the main-app
 * route would navigate the iframe out of the CRM with no way back.
 */

import { Path } from 'constants/router'

export const flagOffFallbackPath = (isEmbed: boolean): string =>
  isEmbed ? Path.EMBED_PURCHASE_FLOW : Path.PURCHASE_FLOW
